import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f3ef6fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "card-activity",
  class: "card-activity"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Comentário: "), -1))
const _hoisted_3 = { class: "flex flex-row items-center gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Anexo enviado: "), -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: ""
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "py-4" }, /*#__PURE__*/_toDisplayString("Feedbacks"), -1))
const _hoisted_9 = { class: "feedback-card" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Nota: "), -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Comentários do Professor:"), -1))
const _hoisted_12 = { class: "flex flex-col gap-4 py-4" }
const _hoisted_13 = { for: "input-score" }
const _hoisted_14 = { class: "flex flex-col gap-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "input-feedback" }, /*#__PURE__*/_toDisplayString("Descrição da Atividade"), -1))
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-2 items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createElementVNode("p", null, /*#__PURE__*/_toDisplayString("Após a correção, a nota e feedback não poderão ser editados"))
], -1))
const _hoisted_18 = { class: "flex justify-end gap-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.studentActivity?.student?.name ?? 'Atividade Aluno',
    visible: _ctx.show,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:show', $event))),
    modal: "",
    style: { width: '60vw', minWidth: '300px', maxWidth: '800px' }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Loader, {
        loader: _ctx.loading?.activity
      }, null, 8, ["loader"]),
      (!_ctx.loading?.activity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("header", null, [
              _createElementVNode("h4", null, _toDisplayString(`Atividade Enviada - ${_ctx.studentActivity?.title}`), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.studentActivity?.textAnswer ?? "Nenhum comentário adicionado"), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_ctx.studentActivity?.mediaAnswer?.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.studentActivity?.mediaAnswer, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.id
                    }, [
                      _createElementVNode("div", {
                        class: "flex flex-row justify-between items-center bg-h-primary-50 pr-4 cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadActivity(file))
                      }, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-file",
                          class: "btn-simple",
                          label: file.name + '.' + file.mimetype
                        }, null, 8, ["label"]),
                        _createVNode(_component_v_icon, { name: "hi-solid-download" })
                      ], 8, _hoisted_5)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString("Nenhum arquivo anexado")))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.studentActivity?.status.value === 'FEEDBACK')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_ctx.studentActivity?.score ?? "Nenhuma nota atribuída"), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.studentActivity?.feedback ?? "Nenhum feedback adicionado"), 1)
              ])
            ])
          ]))
        : (_ctx.studentActivity?.status.value === 'ASSIGNED')
          ? (_openBlock(), _createElementBlock("form", {
              key: 2,
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCorrection && _ctx.submitCorrection(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(`Pontuação 0 - ${_ctx.studentActivity?.scoreRange} `), 1),
                _withDirectives(_createVNode(_component_InputNumber, {
                  placeholder: 
            _ctx.$t('labels.generic', { pt: 'Insira uma nota', en: 'Insert grade' })
          ,
                  modelValue: _ctx.form.score,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.score) = $event)),
                  id: "input-score",
                  mode: "decimal",
                  min: 0,
                  max: _ctx.studentActivity?.scoreRange,
                  class: _normalizeClass([{ 'p-invalid': _ctx.v$?.score?.$error }])
                }, null, 8, ["placeholder", "modelValue", "max", "class"]), [
                  [
                    _directive_tooltip,
                    
            'Nota e feedback devem ser enviados após o prazo final da atividade'
          ,
                    void 0,
                    {
                      focus: true,
                      top: true
                    }
                  ]
                ]),
                _createVNode(_component_Errors, {
                  errors: _ctx.v$?.score?.$errors
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("textarea", {
                  placeholder: 
            _ctx.$t('labels.generic', {
              pt: 'Adicione um Feedback',
              en: 'Add a Feedback',
            })
          ,
                  rows: "5",
                  cols: "20",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.feedback) = $event)),
                  class: _normalizeClass(["border rounded-md p-3 p-inputtext", [{ 'p-invalid': _ctx.v$?.feedback?.$error }]]),
                  style: { resize: 'none' }
                }, null, 10, _hoisted_16), [
                  [_vModelText, _ctx.form.feedback],
                  [
                    _directive_tooltip,
                    
            'Nota e feedback devem ser enviados após o prazo final da atividade'
          ,
                    void 0,
                    {
                      focus: true,
                      top: true
                    }
                  ]
                ]),
                _createVNode(_component_Errors, {
                  errors: _ctx.v$?.feedback?.$errors
                }, null, 8, ["errors"]),
                _hoisted_17
              ]),
              _createElementVNode("span", _hoisted_18, [
                _createVNode(_component_Button, {
                  onClick: _ctx.cancelCorrection,
                  label: _ctx.$t('labels.generic', { en: 'Cancel', pt: 'Cancelar' }),
                  class: "btn-outline"
                }, null, 8, ["onClick", "label"]),
                _createVNode(_component_Button, {
                  type: "submit",
                  label: _ctx.$t('labels.generic', { en: 'Correct', pt: 'Corrigir' }),
                  loading: _ctx.loading?.submit,
                  class: "btn-primary"
                }, null, 8, ["label", "loading"])
              ])
            ], 32))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}